export default "__VITE_ASSET__44c76c42__"